import React, { useRef, useState } from 'react';
import Modal from 'react-modal';
import SignatureCanvas from 'react-signature-canvas';
import { PDFDocument } from 'pdf-lib';
import { MonoButton } from "../kits/DesignKit";

Modal.setAppElement('#root');

const PdfSignerModal = ({ isOpen, onClose, pdfUrl, userId, course, onSigned }) => {
  const sigPadRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleClear = () => sigPadRef.current.clear();

const handleSubmit = async () => {
  // 1. Prüfen, ob das Signaturfeld leer ist
  if (sigPadRef.current.isEmpty()) {
    setError("Bitte unterschreiben Sie zuerst im markierten Feld.");
    return;
  }

  setIsLoading(true);
  setError(null);

  try {
    // WICHTIG: Dies kann aufgrund von CORS fehlschlagen, wenn der Server keine Erlaubnis gibt.
    // Stelle sicher, dass dein Server (denisbitter.de) den Header 'Access-Control-Allow-Origin' sendet.
    const pdfResponse = await fetch(pdfUrl);
    if (!pdfResponse.ok) {
      throw new Error(`PDF-Dokument nicht gefunden oder Ladefehler (Status: ${pdfResponse.status})`);
    }
    const existingPdfBytes = await pdfResponse.arrayBuffer();
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const firstPage = pdfDoc.getPages()[0];
    const { width, height } = firstPage.getSize(); // Seitengröße für relative Positionierung holen

    const signatureCanvas = sigPadRef.current.getCanvas();
    const signatureDataUrl = signatureCanvas.toDataURL('image/png');
    const pngImageBytes = await fetch(signatureDataUrl).then(res => res.arrayBuffer());
    const pngImage = await pdfDoc.embedPng(pngImageBytes);

    // 2. Signatur proportional skalieren und besser positionieren
    const pngDims = pngImage.scale(0.25); // Skaliere das Bild auf 25% seiner Größe

    firstPage.drawImage(pngImage, {
      x: 50, // Etwas Abstand vom linken Rand
      y: 80, // Etwas Abstand vom unteren Rand
      width: pngDims.width,
      height: pngDims.height,
    });

    const signedPdfBytes = await pdfDoc.save();
    const signedBlob = new Blob([signedPdfBytes], { type: 'application/pdf' });

    const formData = new FormData();
    // 3. Eindeutigeren Dateinamen für den Upload verwenden
    const fileName = `signed_${course}_${userId}.pdf`;
    formData.append('file', signedBlob, fileName);
    formData.append('user_id', userId);
    formData.append('course', course);

    const response = await fetch('https://www.denisbitter.de/stage01/api/upload_signed_pdf.php', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Serverfehler: ${response.status} - ${errorText}`);
    }
    const result = await response.json();    if (!result.success) throw new Error(result.message || 'Fehler beim Upload');

    onSigned?.();
    onClose?.();
  } catch (err) {
    console.error('❌ Fehler beim Signieren:', err);
    setError(err.message || 'Beim Signieren ist ein Fehler aufgetreten.');
  } finally {
    setIsLoading(false);
  }
};


  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="PDF Signatur"
      className="bg-gray-50 p-4 max-w-3xl w-full mx-auto mt-20 rounded-lg shadow-lg outline-none border 
      border-zinc-800"
      overlayClassName="fixed inset-0 bg-white/90 z-50 flex justify-center items-start"
    >
      <h2 className="text-lg font-bold mb-2">PDF Vorschau & Signatur</h2>

      <iframe
        src={pdfUrl}
        title="PDF Vorschau"
        className="w-full h-96 border mb-4"
      />

      <p className="mb-2 text-xs font-mono text-center">Bitte hier unterschreiben:</p>
      
      <SignatureCanvas
        ref={sigPadRef}
        penColor="black"
        canvasProps={{ width: 400, height: 150, className: "border-2 border-dashed border-gray-400 bg-gray-100 mx-auto mb-4" }}
      />

          <MonoButton
          onClick={handleSubmit}
          disabled={isLoading}
          className="px-4 py-2 rounded text-xs w-full"
        >
          {isLoading ? 'Wird gesendet...' : 'Signieren & Senden'}
        </MonoButton>
        <div className='mt-4'>
        <MonoButton onClick={handleClear} 
        className="text-xs text-gray-600 hover:text-black w-full">Zurücksetzen</MonoButton>

        <MonoButton onClick={onClose} 
        className="text-xs text-gray-600 hover:text-black w-full mt-2">Zurück Dashboard</MonoButton>
        </div>  

        


      

      {error && <p className="mt-2 text-red-500 text-sm text-bold 
      font-mono justify-center text-center">{error}</p>}
    </Modal>
  );
};

export default PdfSignerModal;
